import { RADAR_AXES } from "@/lib/peer-group/radar";

export interface AxisComparisonRow {
  axis: string;
  target: number | undefined;
  peerMedian: number | undefined;
}

/** Qualitätsprofil als horizontale Balkenpaare statt Radar/Spinnennetz-Chart - auf
 * Eriks Wunsch besser erkennbar und einfacher verständlich als ein 5-Achsen-Radar.
 * Gleiches Muster wie die Score-KPI-Kacheln (score-kpi-grid.tsx): Label + Wert oben,
 * dünner Fortschrittsbalken darunter. Werte sind 0-100-Skalen (Z-Score-Mittelwert je
 * Achse, siehe lib/peer-group/radar.ts) - 50 entspricht dem Median der Peer-Gruppe. */
export function PeerAxisBars({ data, targetLabel }: { data: AxisComparisonRow[]; targetLabel: string }) {
  return (
    <div className="rounded-lg border border-hairline p-4">
      <div className="mb-1 text-sm font-medium text-ink-secondary">Qualitätsprofil</div>
      <p className="mb-4 text-xs text-muted-foreground">
        {targetLabel} vs. Median der Peer-Gruppe, je Achse 0–100 (50 = Median).
      </p>
      <div className="flex flex-col gap-4">
        {data.map((row) => (
          <div key={row.axis} className="flex flex-col gap-1.5">
            <span className="text-sm text-ink-secondary">{row.axis}</span>
            <div className="flex items-center gap-2">
              <span className="w-14 shrink-0 text-xs text-muted-foreground">{targetLabel}</span>
              <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
                {row.target !== undefined && (
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-ink to-gold"
                    style={{ width: `${row.target}%` }}
                  />
                )}
              </div>
              <span className="w-9 shrink-0 text-right font-tabular text-xs text-ink">
                {row.target !== undefined ? row.target.toFixed(0) : "–"}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-14 shrink-0 text-xs text-muted-foreground">Median</span>
              <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
                {row.peerMedian !== undefined && (
                  <div
                    className="h-full rounded-full bg-muted-foreground/40"
                    style={{ width: `${row.peerMedian}%` }}
                  />
                )}
              </div>
              <span className="w-9 shrink-0 text-right font-tabular text-xs text-muted-foreground">
                {row.peerMedian !== undefined ? row.peerMedian.toFixed(0) : "–"}
              </span>
            </div>
          </div>
        ))}
      </div>
      {data.length !== RADAR_AXES.length && (
        <p className="mt-3 text-[10px] text-muted-foreground">
          Manche Achsen fehlen mangels ausreichender Datenbasis in der Peer-Gruppe.
        </p>
      )}
    </div>
  );
}
